/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum ProviderCredentialV2OrderValue {
    Supplier = 'Supplier',
    BrandAndMarket = 'BrandAndMarket',
    DistributionChannel = 'DistributionChannel',
    Agency = 'Agency'
}

export function ProviderCredentialV2OrderValueFromJSON(json: any): ProviderCredentialV2OrderValue {
    return ProviderCredentialV2OrderValueFromJSONTyped(json, false);
}

export function ProviderCredentialV2OrderValueFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProviderCredentialV2OrderValue {
    return json as ProviderCredentialV2OrderValue;
}

export function ProviderCredentialV2OrderValueToJSON(value?: ProviderCredentialV2OrderValue | null): any {
    return value as any;
}

